import { ESupplyInfoDialogMutations, } from '@/vuex-store/supply-info-dialog/types';
const mutations = {
    [ESupplyInfoDialogMutations.SET_IS_SUPPLY_INFO_DIALOG_OPEN](state, isOpen) {
        state.isSupplyInfoDialogOpen = isOpen;
    },
    [ESupplyInfoDialogMutations.SET_SUPPLIERS_INFO](state, info) {
        state.suppliersInfo = info;
    },
    [ESupplyInfoDialogMutations.RESET_SUPPLIERS_INFO](state) {
        state.suppliersInfo = null;
    },
};
export default mutations;
